export enum ParentType {
    None = 0,
    Invoice = 1,
    Consultation = 2,
    Document = 3,
    Antecedent = 4,
    User = 5,
    Patient = 6,
}
